<script>
    import {fade} from 'svelte/transition';
    import Sustainability from './sustainability.svelte';
    const {title, goto} = rpcjs.props;
    title.set('Future of Entertainment');
    let nextPage = false;
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            nextPage = true;
        }
        if (e.key == 'ArrowLeft') {
            goto('/futureOfGaming');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>
<div
    class="main"
    role="presentation"
    on:click={() => {
        nextPage = true;
    }}
>
    {#if !nextPage}
        <div transition:fade={{duration: 300}}>
            <div class="img-wrapper">
                <img
                    width="100%"
                    height="100%"
                    src="images/web3_pages/opus_portal.png"
                    alt="background img"
                    class = 'img'
                />
            </div>
            <div class="center">
                <div class="center-top">
                    <p class="opus">OPUS IS</p>
                    <div class="building-img">
                        <img
                            width="100%"
                            height="100%"
                            src="images/web3_pages/building.svg"
                            alt="BUILDING"
                        />
                    </div>
                    <p class="future">THE FUTURE OF</p>
                    <p class="entertainment">ENTERTAINMENT</p>
                </div>
                <p class="center-bottom">
                    The future of humanity lies at the apex of gaming & web3,
                    enabling us to create a
                    <br />
                    <span style="font-weight: 900;">
                        self-sustaining community of creators with a circular
                        economy
                    </span>
                </p>
            </div>
        </div>
    {:else}
    <div  in:fade={{duration: 1000}}>
        <Sustainability />
    </div>
    {/if}
</div>

<style>
    .main {
        position: relative;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background-color: #010422;
    }
    .img-wrapper {
        width: 100vw;
        height: 100vh;
        pointer-events: none;
    }
    .img{
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
    .center {
        width: 85.885vw;
        position: absolute;
        top: 14.063vw;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 1;
    }
    .center-top {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 900;
        color: #ffffff;
    }
    .opus {
        font-size: 2.604vw;
        line-height: 85%;
        margin-left: 15.625vw;
    }
    .building-img {
        width: 41.198vw;
        height: 6.667vw;
        margin-left: 15.625vw;
        pointer-events: none;
    }
    .future {
        font-size: 5.208vw;
        margin-left: 29.063vw;
        line-height: 85%;
    }
    .entertainment {
        font-size: 10.417vw;
        color: #ff007f;
        text-shadow: 0vw 0.208vw 0.104vw rgba(0, 0, 0, 0.9);
        line-height: 85%;
        letter-spacing: -0.08em;
    }
    .center-bottom {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 400;
        font-size: 1.563vw;
        line-height: 120%;
        text-align: center;
        color: #ffffff;
        margin-top: 5vw;
    }
    p {
        margin: 0;
        padding: 0;
    }
</style>
